// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import { actionSetAuthUser } from '@/modules/application/actions/auth';

const initialValues = {
    username: '',
    password: '',
};

const initialErrors = {
    username: '',
    password: '',
};

let abortController;

const Login = (props) => {
    // noinspection JSUnusedLocalSymbols
    const [open, setOpen] = useState(true);
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        document.title = 'Tracker - Вход';
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post('/api/auth/login/', {username: values.username, password: values.password}, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.setAuthUser(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.username = (data.username) ? data.username[0] : '';
                    _errors.password = (data.password) ? data.password[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    return (
        <DialogForm title="Вход" label="Войти"
                    open={open} onClose={() => {}}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <TextField label="Имя пользователя" type="email"
                       value={values.username} onChange={handleChange('username')}
                       error={errors.username.length > 0}
                       helperText={errors.username}
                       onFocus={handleFocus('username')}
                       autoFocus={true}
            />
            <TextField label="Пароль" type="password"
                       value={values.password} onChange={handleChange('password')}
                       error={errors.password.length > 0}
                       helperText={errors.password}
                       onFocus={handleFocus('password')}
            />
        </DialogForm>
    );
};

let Component = Login;
Component = withFetch(Component);

export default connect(
    null,
    (dispatch) => ({
        setAuthUser: bindActionCreators(actionSetAuthUser, dispatch),
    })
)(Component);
